qw-book-condition {
  display: flex;
  padding: var(--qw-hotel-gap-sm);
}

qw-book-condition > div {
  margin: var(--qw-hotel-gap-sm) 0;
}
